import React, { Component, memo } from 'react';

import { withRouter } from 'react-router-dom';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withTranslation } from 'react-i18next';
import { toastr } from 'react-redux-toastr';
import { IaCreators } from '../../../../store/actions/intelligence';
import { BotsCreators } from '../../../../store/actions/bots';

import fechar from '../../img/fechar.svg';
import edit from '../../img/edit_create.svg';
import deleteC from '../../img/icon_delete_create.svg';
import './CreateCard.scss';
import pontilhado from '../../img/pontilhado.svg';
import CirclePoint from '../CirclePoint/CirclePoint';

class CreateCard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      nome: '',
      text: '',
      userItem: [],
      userEntity: {},
      synonyms: [],
      objects: [],
      entidade: '',
      nameObj: '',
      sinonimo: '',
      updatedEntIndex: -1,
    };
    this.onChangItem = this.onChangItem.bind(this);
    this.handleSubmitIntent = this.handleSubmitIntent.bind(this);
    this.handleSubmitEntity = this.handleSubmitEntity.bind(this);
    this.addSynonyms = this.addSynonyms.bind(this);
  }

  onChang = (e) => {
    if (this.props.blt === 'intencoes') {
      this.setState({
        nome: e.target.value,
      });
    } else {
      this.setState({
        entidade: e.target.value,
      });
    }
  };

  onChangItem = (e) => {
    this.setState({
      text: e.target.value,
    });
  };

  onChangEnt = (e) => {
    this.setState({
      entidade: e.target.value,
    });
  };

  onChangObj = (e) => {
    this.setState({
      nameObj: e.target.value,
    });
  };

  onChangSin = (e) => {
    this.setState({
      sinonimo: e.target.value,
    });
  };

  addSynonyms(e) {
    e.preventDefault();

    if (this.state.sinonimo !== '') {
      const newSynonyms = [this.state.sinonimo];
      this.setState((state) => ({
        synonyms: state.synonyms.concat(newSynonyms),
        sinonimo: '',
      }));
    } else {
      toastr.error('Erro', 'Não pode adicionar um sinônimo vazio');
    }
  }

  deleteSynonyms(item) {
    const { synonyms } = this.state;
    this.setState({
      synonyms: synonyms.filter((element) => element !== item),
    });
  }

  addObj = () => {
    if (this.state.nameObj !== '' && this.state.synonyms.length > 0) {
      const newObj = [
        {
          name: this.state.nameObj,
          synonyms: this.state.synonyms,
        },
      ];
      this.setState((state) => ({
        objects: state.objects.concat(newObj),
      }));
    } else {
      toastr.error('Erro', 'Não pode adicionar um objeto vazio');
    }
  };

  handleSubmitEntity = async (e) => {
    e.preventDefault();
    await this.addObj();

    if (
      this.state.entidade !== '' &&
      this.state.nameObj !== '' &&
      this.state.synonyms.length > 0
    ) {
      const newItem = {
        entidade: this.state.entidade,
        objects: this.state.objects,
      };

      await this.setState({
        userEntity: newItem,
        nameObj: '',
        sinonimo: '',
        synonyms: [],
      });
    } else if (this.state.entidade === '') {
      toastr.error('Erro', 'Entidade não pode ser vazia');
    } else if (this.state.nameObj === '') {
      toastr.error('Erro', 'Objeto não pode ser vazio');
    } else if (this.state.synonyms.length === 0) {
      toastr.error('Erro', 'sinônimo não pode ser vazia');
    }
  };

  handleSubmitIntent(e) {
    e.preventDefault();
    if (this.state.text.length === 0) {
      return;
    }
    const newItem = {
      text: this.state.text,
    };
    const hasEqual = this.state.userItem.find(
      (item) => item.text === newItem.text
    );

    if (this.state.updatedEntIndex !== -1 || hasEqual) {
      const userItem = this.state.userItem.map((item, index) => {
        if (!hasEqual) {
          return index === this.state.updatedEntIndex ? newItem : item;
        }
        return this.state.text === item.text ? newItem : item;
      });
      this.setState({ userItem, text: '', updatedEntIndex: -1 });
    } else {
      this.setState((state) => ({
        userItem: state.userItem.concat(newItem),
        text: '',
        updatedEntIndex: -1,
      }));
    }
  }

  editItem(item) {
    const updatedEntIndex = this.state.userItem.indexOf(item);
    this.setState(() => ({ updatedEntIndex }));
    if (updatedEntIndex !== -1) {
      const { text } = this.state.userItem[updatedEntIndex];
      this.setState({ text });
    }
  }

  deleteItem(item) {
    const { userItem } = this.state;

    const userItemFilter = userItem.filter((element) => element.text !== item);

    this.setState({
      userItem: userItemFilter,
    });
  }

  deleteEntity(item) {
    const { userEntity } = this.state;

    const userEntityFiler = userEntity.objects.filter(
      (element, index) => index !== item
    );

    this.setState({
      userEntity: {
        ...userEntity,
        objects: userEntityFiler,
      },
      objects: userEntityFiler,
    });
  }

  addIsInfo = async () => {
    const { nome, userItem } = this.state;
    const { createIntents, newCard, bot } = this.props;
    let erro = false;

    if (this.props.blt === 'intencoes') {
      const verificaEspaco = (nome) => nome.indexOf(' ') !== -1;

      if (nome === '') {
        toastr.error('Erro', 'Intenção não pode ser vazia');
        erro = true;
      }

      if (userItem.length === 0) {
        toastr.error('Erro', 'Frases não podem ser vazias');
        erro = true;
      }

      this.props.intents.map((element) => {
        if (element.cleanName == nome.toLowerCase().replace(/\s/g, '_')) {
          toastr.error('Erro', 'Intenção com o mesmo nome já criada!');
          erro = true;
        }
      });

      if (!erro) {
        await createIntents(bot.currentTokenIa, nome, this.state.userItem);
        await newCard();
      }
    } else if (JSON.stringify(this.state.userEntity) !== '{}') {
      await this.props.createEntities(
        bot.currentTokenIa,
        this.state.userEntity.entidade,
        this.state.userEntity.objects
      );
      await newCard();
    } else {
      toastr.error('Erro', 'Não existe intenção criada');
    }
  };

  render() {
    const { blt, newCard } = this.props;
    const { userItem, nome, userEntity, entidade, nameObj, sinonimo } =
      this.state;

    return (
      <div>
        <div className="container-card-buttons">
          <button
            type="button"
            style={{ backgroundColor: '#0D84FF', color: 'white' }}
            onClick={this.addIsInfo}
          >
            salvar
          </button>
          <button type="button" onClick={newCard}>
            reverter
          </button>
        </div>
        <div className="mod-create">
          <p>Nova {blt === 'intencoes' ? 'Intenção' : 'Entidade'}</p>
          <div className="container-input-card">
            <span>nome da {blt === 'intencoes' ? 'intenção' : 'entidade'}</span>
            <input
              placeholder={blt === 'intencoes' ? 'intenção' : 'entidade'}
              onChange={this.onChang}
              value={blt === 'intencoes' ? nome : entidade}
            />
          </div>
          <div className="cont-circle-mod">
            <p style={{ marginRight: 10 }}>
              {blt === 'intencoes' ? 'Exemplo' : 'Objeto'}
            </p>
            {blt === 'intencoes' && <CirclePoint item={userItem.length} />}
          </div>
          {blt === 'intencoes' ? (
            <span>
              Crie exemplos de frase de usuário para aperfeiçoar a IA, quanto
              mais, melhor!{' '}
              <span style={{ color: '#008DFA' }}>
                Aperte enter para criar novas.
              </span>
            </span>
          ) : (
            <span>
              Objeto são os itens pertencentes ao grupo, por exemplo: entidade=
              cores, obj. = azul, amarelo, vermelho.
            </span>
          )}

          <div className="container-obj-sin">
            {blt === 'intencoes' ? (
              <form className="container-obj-sin">
                <input
                  className="input-redond-int"
                  placeholder="exemplo de frase de usuário"
                  maxLength="280"
                  onChange={this.onChangItem}
                  value={this.state.text}
                />
                <button
                  onClick={this.handleSubmitIntent}
                  className="btn-adicionar"
                  type="submit"
                >
                  adicionar
                </button>
              </form>
            ) : (
              <div>
                <form onSubmit={this.addSynonyms} className="container-obj-sin">
                  <input
                    placeholder="objeto"
                    style={{ width: 250 }}
                    onChange={this.onChangObj}
                    value={nameObj}
                  />
                  <div className="container-ipt-sin" style={{ width: 337 }}>
                    <input
                      placeholder="sinônimo"
                      onChange={this.onChangSin}
                      value={sinonimo}
                    />
                  </div>
                  <button
                    className="btn-adicionar"
                    onClick={this.addSynonyms}
                    type="submit"
                  >
                    adicionar
                  </button>
                </form>
                <div className="container-syn">
                  {this.state.synonyms.map((syn) => (
                    <div className="spn-syn">
                      {syn}
                      <img
                        onClick={() => this.deleteSynonyms(syn)}
                        src={fechar}
                        alt="Icon close"
                      />
                    </div>
                  ))}
                </div>
                <div className="container-btn-adicionar">
                  <button onClick={this.handleSubmitEntity} type="button">
                    Criar objetos
                  </button>
                </div>
              </div>
            )}
          </div>

          <p style={{ marginTop: 18 }}>
            {blt === 'intencoes' ? 'Exemplos' : 'Objetos'} Criados (
            {this.state.userItem.length}){' '}
            {blt != 'intencoes' && <img alt="" src={pontilhado} />}
          </p>
          <div className="container-objt-criados">
            {this.state.userItem.map((item) => (
              <div className="container-exemplos-criados">
                <div
                  className={
                    blt === 'intencoes' ? 'exemplos-criados' : 'objetos-criados'
                  }
                >
                  <p>{item.text}</p>
                </div>
                <div className="cont-img-ent">
                  <img
                    alt=""
                    src={edit}
                    onClick={() => this.editItem(item)}
                    style={{ cursor: 'pointer' }}
                  />
                  <img
                    alt=""
                    onClick={() => this.deleteItem(item.name)}
                    src={deleteC}
                    style={{ cursor: 'pointer' }}
                  />
                </div>
              </div>
            ))}

            {userEntity?.objects?.map((ob, index) => (
              <div className="container-entity-obj">
                <div className="area-entity-obj">
                  <div style={{ display: 'flex' }}>
                    <span>{ob.name}</span>:
                    {ob.synonyms.map((syn) => (
                      <div style={{ display: 'flex' }}>
                        <span className="spn-syn-margin">{syn}</span>;
                      </div>
                    ))}
                  </div>
                </div>
                <div>
                  {/* <img src={edit} style={{ cursor: 'pointer' }} /> */}
                  <img
                    alt=""
                    onClick={() => this.deleteEntity(index)}
                    src={deleteC}
                    style={{ cursor: 'pointer' }}
                  />
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  ia: state.intelligence.ia,
  intents: state.intelligence.intents,
  bot: state.bots.bot,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      ...IaCreators,
      ...BotsCreators,
    },
    dispatch
  );

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(withTranslation()(memo(CreateCard)))
);
